export default __webpack_public_path__ + "static/media/picThanhNguyen.5801603a.png";